import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	title: {
		color: colors.purple[400]
	},
	titleIcon: {
		color: colors.purple[400]
	},
	spacedText: {
		marginTop: "10px"
	},
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	}
}))

export default useStyles
